import { render, staticRenderFns } from "./PlansUTMTable.vue?vue&type=template&id=c31298a2&scoped=true&"
import script from "./PlansUTMTable.vue?vue&type=script&lang=js&"
export * from "./PlansUTMTable.vue?vue&type=script&lang=js&"
import style0 from "./PlansUTMTable.vue?vue&type=style&index=0&id=c31298a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31298a2",
  null
  
)

export default component.exports